import Cookies from 'js-cookie';
import isbot from 'isbot';

const CONSENT_COOKIE = 'ccCookieConsent';
const CONSENT_ACCEPTED = 'accepted';
const CONSENT_REJECTED = 'rejected';

document.addEventListener('DOMContentLoaded', () => {
  const notice = document.getElementById('ccCookiesNotice');
  if (!notice) return;

  const expiresHours = parseFloat(notice.getAttribute('data-expires')) || 2160;
  const expiresDays = expiresHours / 24;

  function close() {
    notice.setAttribute('hidden', 'true');
  }

  function setConsent(value) {
    Cookies.set(CONSENT_COOKIE, value, { expires: expiresDays });
  }

  function init() {
    if (isbot(navigator.userAgent)) return;

    const consent = Cookies.get(CONSENT_COOKIE);
    if (!consent) {
      notice.removeAttribute('hidden');
    }
  }

  notice.querySelector('.site-notice__accept')?.addEventListener('click', () => {
    setConsent(CONSENT_ACCEPTED);
    close();
  });

  notice.querySelector('.site-notice__reject')?.addEventListener('click', () => {
    setConsent(CONSENT_REJECTED);
    close();

    if (typeof gtag === 'function') {
      gtag('event', 'cookie_consent_reject', {
        transport_type: 'beacon',
        event_callback: () => window.location.reload(),
        event_timeout: 2000,
      });
    } else {
      window.location.reload();
    }
  });

  init();
});
